import { Reducer } from 'redux';

import {
  GET_SCHEDULES_FAILED,
  GET_SCHEDULES_REQUEST,
  GET_SCHEDULES_SUCCESS,
  RESET_SCHEDULES,
} from '../constants/actionTypes';
import { ScheduleI } from '../../../interfaces/schedule.interface';
import { ThunkAnyAction } from '../../../services/apiMiddleware';
import { mapIdToData } from '../../../utils';

export interface ScheduleStateI {
  loading: boolean;
  error?: Record<string, string>;
  byId?: Record<string, ScheduleI>;
}

export function getInitialSchedulesState(): ScheduleStateI {
  return {
    loading: false,
  };
}

const schedulesReducer: Reducer<ScheduleStateI, ThunkAnyAction> = (
  state = getInitialSchedulesState(),
  action,
) => {
  switch (action.type) {
    case GET_SCHEDULES_REQUEST: {
      return { ...state, loading: true };
    }
    case GET_SCHEDULES_SUCCESS: {
      return { ...state, loading: false, byId: mapIdToData(action.response.data) };
    }
    case GET_SCHEDULES_FAILED: {
      return { ...state, loading: false, error: action.payload };
    }
    case RESET_SCHEDULES: {
      return { ...state, byId: undefined };
    }
    default:
      return state;
  }
};

export default schedulesReducer;
